<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 0H10.6667V2H9.33333V1.33333H1.33333V12H4.66667V13.3333H0V0ZM5.33333 2.66667H16V16H5.33333V2.66667ZM6.66667 4V14.6667H14.6667V4H6.66667Z" fill="#377DA4"/>
  </svg>
</template>